<template>
<div>

    <div class="header-banner">
      <section class="block">
        <div class="container">
            <h1>
            <nav class="admin breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li><router-link tag="a" :to="{name: 'admin'}">Admin</router-link></li>
                <li class="is-active"><a href="#">Edit About page</a></li>
              </ul>
            </nav>
                Edit About page
            </h1>
        </div>
      </section>
    </div>

    <div class="section">

        <div class="container">
          <h2 class="title">
            <router-link tag="a" :to="{name: 'about'}" class="button is-text" target="_blank">View</router-link>
            </h2>

          <form class="edit-form" id="edit-form" v-model="valid" ref="form" lazy-validation v-on:submit.prevent>
            
            <div class="columns">
                <div class="column main is-two-thirds">

                    <input type="hidden" name="_token" value="arhghgjuythf" />
                    <input type="hidden" name="_username" v-model="username" v-validate="'required'">

                    <div class="field">
                        <label class="label">Text *</label>
                        <div class="control">
                          <vue-editor name="text" v-model="item.text" v-validate="'min:3'" v-bind:class="{'is-danger': errors.has('text')}"></vue-editor>
                        </div>
                        <p class="help is-danger" v-show="errors.has('text')">
                          {{ errors.first('text') }}
                        </p>
                    </div>
                
                    <div class="field">
                        <label class="label">Committee members *</label>
                        <div class="control">
                          <vue-editor name="committeeMembers" v-model="item.committeeMembers" v-validate="'min:3'" v-bind:class="{'is-danger': errors.has('committeeMembers')}"></vue-editor>
                        </div>
                        <p class="help is-danger" v-show="errors.has('committeeMembers')">
                          {{ errors.first('committeeMembers') }}
                        </p>
                    </div>
                    


                    <section class="section">
                        <div class="field is-grouped">
                          <div class="control">
                            <!-- <button @click="submit" :disabled="!valid">Save changes</button> -->
                            <button class="button is-primary" v-bind:disabled="errors.any()" @click="submit">Save changes</button>
                          </div>
                          <div class="control">
                            <button class="button is-text" id="cancel" @click="cancel">Close</button>      
                          </div>
                        </div>
                    </section>

                </div>

            </div>

          </form>
            

          <ul class="navbar-nav ml-auto">
              <!-- <li class="nav-item active" v-for="item in item.plays" :key="item._id">
                  <router-link tag="a" :to="{name: 'adminPlay', params: {item: item}}" class="nav-link" target="_blank">Edit </router-link>
                  <router-link tag="a" :to="{name: 'play', params: {slug: item.slug}}" class="nav-link" target="_blank">View </router-link>
                  {{ item.title }}
              </li> -->
          </ul>

        </div>

        
    </div>

</div>
</template>

<script>
import Api from '@/config/Api'
import { mapGetters, mapState } from 'vuex'
//import Datepicker from 'vuejs-datepicker'
import { VueEditor } from 'vue2-editor' //for HTML WYSIWYG editor


//import FileUpload from '../FileUpload';

export default {
    data() {
        return {
            item: {},
            error: false,
            valid: true,
        }
    },
    components: {
        //FileUpload,
        //Datepicker,
        VueEditor
    },
    computed: {
        ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
        ...mapState({
          authLoading: state => state.status === 'loading',
          name: state => `${state.user.profile.name}`, 
        }),
        username() {
            var n = this.name;
            if (n == 'undefined') n = "not logged in";
            return n;
        }
    },    
    created() {
        Api().get(`/api/about`).then(response => {
            this.item = response.data;
        });
    },
    methods: {
      submit(evt) {
        evt.preventDefault()

        //const { email, password } = this
        var item = this.item
        console.log("item:",item)

        Api().put(`/api/about`, item)
        .then(response => {
          this.$swal('Saved!', '', 'success');
          //this.$router.push({ name: 'admin' });
        })
        .catch((error) => {
          console.log("errorrrr:",error);
          const message = error.response.data.message;
          this.$swal('Oh oo!', `${message}`, 'error');
        });
      },
      cancel() {
          this.$router.push({ name: 'admin' });
          //this.$router.go(-1); // go back to previous page
      }
      
    }
  }
</script>


<style>


</style>



// WEBPACK FOOTER //
// src/components/accounts/AdminAbout.vue